import { Over, Active } from '@dnd-kit/core';
import { ItemsI } from '../types';
import { findContainerId } from './findContainerId';

/**
 * OnDragOver.
 */
export const onDragOver = ({
  active,
  over,
  items,
  setItems,
  recentlyMovedToNewContainer,
}: {
  over: Over;
  active: Active;
  items: ItemsI;
  recentlyMovedToNewContainer: React.MutableRefObject<boolean>;
  setItems: (value: React.SetStateAction<ItemsI>) => void;
}) => {
  const overId = over.id ?? -1;
  const activeId = active.id ?? -1;

  const overContainerId = findContainerId(overId, items) as any; // FIXME: any
  const activeContainerId = findContainerId(activeId, items) as any; // FIXME: any

  if (activeContainerId !== overContainerId) {
    setItems((items) => {
      const activeItems = items[activeContainerId];
      const overItems = items[overContainerId];
      const overIndex = overItems.indexOf(overId);
      const activeIndex = activeItems.indexOf(active.id);

      let newIndex: number;

      if (overId in items) {
        newIndex = overItems.length + 1;
      } else {
        const isBelowOverItem =
          over &&
          active.rect.current.translated &&
          active.rect.current.translated.top > over.rect.top + over.rect.height;

        const modifier = isBelowOverItem ? 1 : 0;

        newIndex = overIndex >= 0 ? overIndex + modifier : overItems.length + 1;
      }

      recentlyMovedToNewContainer.current = true;

      return {
        ...items,
        [activeContainerId]: items[activeContainerId].filter(
          (item) => item !== active.id,
        ),
        [overContainerId]: [
          ...items[overContainerId].slice(0, newIndex),
          items[activeContainerId][activeIndex],
          ...items[overContainerId].slice(
            newIndex,
            items[overContainerId].length,
          ),
        ],
      };
    });
  }
};
